import { callable } from '../callable';

export type JournalVisibility = 'private' | 'mentor' | 'faculty' | 'seminary';

export interface JournalEntryDto {
  id: string;
  title: string;
  body: string;
  visibility: JournalVisibility;
  tags: string[];
  createdAt: string;
  updatedAt: string;
}

export const journalApi = {
  listMine: async (data: {
    tenantId: string;
    studentId?: string;
  }): Promise<{ items: JournalEntryDto[] }> => {
    const fn = callable<typeof data, { items: JournalEntryDto[] }>('listMyJournal');
    return (await fn(data)).data;
  },
  create: async (data: {
    tenantId: string;
    studentId?: string;
    title: string;
    body: string;
    visibility?: JournalVisibility;
    tags?: string[];
  }): Promise<{ id: string }> => {
    const fn = callable<typeof data, { id: string }>('createJournalEntry');
    return (await fn(data)).data;
  },
  update: async (data: {
    tenantId: string;
    studentId?: string;
    entryId: string;
    patch: { title?: string; body?: string; visibility?: JournalVisibility; tags?: string[] };
  }): Promise<{ success: boolean }> => {
    const fn = callable<typeof data, { success: boolean }>('updateJournalEntry');
    return (await fn(data)).data;
  },
  delete: async (data: {
    tenantId: string;
    studentId?: string;
    entryId: string;
  }): Promise<{ success: boolean }> => {
    const fn = callable<typeof data, { success: boolean }>('deleteJournalEntry');
    return (await fn(data)).data;
  },
};
